/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 1sKx9ffix1qWmdscEUQHh6
// Component: NAltgsviawN1
import * as React from "react";
import {
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import ButtonNav2 from "../../ButtonNav2"; // plasmic-import: RH3yRCzHERqC/component
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: 1sKx9ffix1qWmdscEUQHh6/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: 1sKx9ffix1qWmdscEUQHh6/projectcss
import sty from "./PlasmicSectionFooter.module.css"; // plasmic-import: NAltgsviawN1/css
import image2OMh955C2SHw from "./images/image2.svg"; // plasmic-import: o-Mh955C2SHw/picture

createPlasmicElementProxy;

export const PlasmicSectionFooter__VariantProps = new Array("layout");

export const PlasmicSectionFooter__ArgProps = new Array("sectionId");

const $$ = {};

function PlasmicSectionFooter__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "layout",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.layout
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  const styleTokensClassNames = _useStyleTokens();
  return (
    <section
      data-plasmic-name={"footer"}
      data-plasmic-override={overrides.footer}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.footer,
        {
          [sty.footerlayout_full]: hasVariant($state, "layout", "full"),
          [sty.footerlayout_withOffset]: hasVariant(
            $state,
            "layout",
            "withOffset"
          )
        }
      )}
      id={(() => {
        try {
          return $props.sectionId;
        } catch (e) {
          if (
            e instanceof TypeError ||
            e?.plasmicType === "PlasmicUndefinedDataError"
          ) {
            return undefined;
          }
          throw e;
        }
      })()}
    >
      <div
        data-plasmic-name={"contentWrapper2"}
        data-plasmic-override={overrides.contentWrapper2}
        className={classNames(projectcss.all, sty.contentWrapper2)}
      >
        <div
          data-plasmic-name={"leftColumn2"}
          data-plasmic-override={overrides.leftColumn2}
          className={classNames(projectcss.all, sty.leftColumn2)}
        >
          <div className={classNames(projectcss.all, sty.freeBox__by6Cp)}>
            <div className={classNames(projectcss.all, sty.freeBox__dGTtx)}>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text___7WuI2
                )}
              >
                {"o21p"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__j9Dro
                )}
              >
                {"/"}
              </div>
              <ButtonNav2
                data-plasmic-name={"buttonNav2"}
                data-plasmic-override={overrides.buttonNav2}
                className={classNames("__wab_instance", sty.buttonNav2)}
                color={"white"}
                iconForButton={
                  <PlasmicImg__
                    data-plasmic-name={"img"}
                    data-plasmic-override={overrides.img}
                    alt={""}
                    className={classNames(sty.img)}
                    displayHeight={"100%"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"none"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"100%"}
                    loading={"lazy"}
                    src={{
                      src: image2OMh955C2SHw,
                      fullWidth: 256,
                      fullHeight: 256,
                      aspectRatio: 1
                    }}
                  />
                }
                onClick={async () => {
                  const $steps = {};
                  $steps["goToHttpsO21PCom"] = true
                    ? (() => {
                        const actionArgs = { destination: "https://o21p.com/" };
                        return (({ destination }) => {
                          if (
                            typeof destination === "string" &&
                            destination.startsWith("#")
                          ) {
                            document
                              .getElementById(destination.substr(1))
                              .scrollIntoView({ behavior: "smooth" });
                          } else {
                            location.assign(destination);
                          }
                        })?.apply(null, [actionArgs]);
                      })()
                    : undefined;
                  if (
                    $steps["goToHttpsO21PCom"] != null &&
                    typeof $steps["goToHttpsO21PCom"] === "object" &&
                    typeof $steps["goToHttpsO21PCom"].then === "function"
                  ) {
                    $steps["goToHttpsO21PCom"] =
                      await $steps["goToHttpsO21PCom"];
                  }
                }}
                shape={"fullRounding"}
                slotSize={"fillButton"}
                status={"normal"}
              />
            </div>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text___6PWnH
              )}
            >
              {
                "\u00a92025 o21p - all rights reserved.\nBuilt and backed by haaaven, SRL."
              }
            </div>
          </div>
        </div>
        <div
          data-plasmic-name={"rightColumn2"}
          data-plasmic-override={overrides.rightColumn2}
          className={classNames(projectcss.all, sty.rightColumn2)}
        >
          <div className={classNames(projectcss.all, sty.freeBox__kk6V6)}>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__xeuak
              )}
            >
              {"COMPANY."}
            </div>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__kgLou
              )}
            >
              <React.Fragment>
                <React.Fragment>{"[ "}</React.Fragment>
                {
                  <PlasmicLink__
                    className={classNames(
                      projectcss.all,
                      projectcss.a,
                      projectcss.__wab_text,
                      projectcss.plasmic_default__inline,
                      sty.link__syQSd,
                      {
                        [sty.linklayout_full__syQSdT38D]: hasVariant(
                          $state,
                          "layout",
                          "full"
                        )
                      }
                    )}
                    href={"https://team.o21p.com/cause"}
                    platform={"react"}
                  >
                    {"cause"}
                  </PlasmicLink__>
                }
                <React.Fragment>{" ]"}</React.Fragment>
              </React.Fragment>
            </div>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__eTaGh
              )}
            >
              <React.Fragment>
                <React.Fragment>{"[ "}</React.Fragment>
                {
                  <PlasmicLink__
                    className={classNames(
                      projectcss.all,
                      projectcss.a,
                      projectcss.__wab_text,
                      projectcss.plasmic_default__inline,
                      sty.link__iz8HX,
                      {
                        [sty.linklayout_full__iz8HXt38D]: hasVariant(
                          $state,
                          "layout",
                          "full"
                        )
                      }
                    )}
                    href={"https://partner.o21p.com/mission"}
                    platform={"react"}
                  >
                    {"mission"}
                  </PlasmicLink__>
                }
                <React.Fragment>{" ]"}</React.Fragment>
              </React.Fragment>
            </div>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__w7KN2
              )}
            >
              <React.Fragment>
                <React.Fragment>{"[ "}</React.Fragment>
                {
                  <PlasmicLink__
                    className={classNames(
                      projectcss.all,
                      projectcss.a,
                      projectcss.__wab_text,
                      projectcss.plasmic_default__inline,
                      sty.link___93CVg
                    )}
                    href={"https://opformypractice.com/legal"}
                    platform={"react"}
                  >
                    {"legal"}
                  </PlasmicLink__>
                }
                <React.Fragment>{" ]"}</React.Fragment>
              </React.Fragment>
            </div>
          </div>
          <div className={classNames(projectcss.all, sty.freeBox__w7OGk)}>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__qfv73
              )}
            >
              {"WEBSITES."}
            </div>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__dTf
              )}
            >
              <React.Fragment>
                <React.Fragment>{"[ "}</React.Fragment>
                {
                  <PlasmicLink__
                    className={classNames(
                      projectcss.all,
                      projectcss.a,
                      projectcss.__wab_text,
                      projectcss.plasmic_default__inline,
                      sty.link__ulQzz,
                      {
                        [sty.linklayout_full__ulQzzt38D]: hasVariant(
                          $state,
                          "layout",
                          "full"
                        )
                      }
                    )}
                    href={"https://partner.o21p.com/"}
                    platform={"react"}
                  >
                    {"partner"}
                  </PlasmicLink__>
                }
                <React.Fragment>{" ]"}</React.Fragment>
              </React.Fragment>
            </div>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text___0Mh2Q
              )}
            >
              <React.Fragment>
                <React.Fragment>{"[ "}</React.Fragment>
                {
                  <PlasmicLink__
                    className={classNames(
                      projectcss.all,
                      projectcss.a,
                      projectcss.__wab_text,
                      projectcss.plasmic_default__inline,
                      sty.link__fpDM,
                      {
                        [sty.linklayout_full__fpDMt38D]: hasVariant(
                          $state,
                          "layout",
                          "full"
                        )
                      }
                    )}
                    href={"https://team.o21p.com/"}
                    platform={"react"}
                  >
                    {"team"}
                  </PlasmicLink__>
                }
                <React.Fragment>{" ]"}</React.Fragment>
              </React.Fragment>
            </div>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__rhgUh
              )}
            >
              <React.Fragment>
                <React.Fragment>{"[ "}</React.Fragment>
                {
                  <PlasmicLink__
                    className={classNames(
                      projectcss.all,
                      projectcss.a,
                      projectcss.__wab_text,
                      projectcss.plasmic_default__inline,
                      sty.link__ar3IH,
                      {
                        [sty.linklayout_full__ar3IHt38D]: hasVariant(
                          $state,
                          "layout",
                          "full"
                        )
                      }
                    )}
                    href={"https://nexus.o21p.com/"}
                    platform={"react"}
                  >
                    {"nexus"}
                  </PlasmicLink__>
                }
                <React.Fragment>{" ]"}</React.Fragment>
              </React.Fragment>
            </div>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__sodM
              )}
            >
              <React.Fragment>
                <React.Fragment>{"[ "}</React.Fragment>
                {
                  <PlasmicLink__
                    className={classNames(
                      projectcss.all,
                      projectcss.a,
                      projectcss.__wab_text,
                      projectcss.plasmic_default__inline,
                      sty.link__sEsLj
                    )}
                    href={"https://opformypractice.com/legal"}
                    platform={"react"}
                  >
                    {"legal"}
                  </PlasmicLink__>
                }
                <React.Fragment>{" ]"}</React.Fragment>
              </React.Fragment>
            </div>
          </div>
          <div className={classNames(projectcss.all, sty.freeBox__jLqRd)}>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__zHvrL
              )}
            >
              {"CONTACT."}
            </div>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__td0T
              )}
            >
              <React.Fragment>
                <React.Fragment>{"[ "}</React.Fragment>
                {
                  <PlasmicLink__
                    className={classNames(
                      projectcss.all,
                      projectcss.a,
                      projectcss.__wab_text,
                      projectcss.plasmic_default__inline,
                      sty.link__g8G7I,
                      {
                        [sty.linklayout_full__g8G7IT38D]: hasVariant(
                          $state,
                          "layout",
                          "full"
                        ),
                        [sty.linklayout_withOffset__g8G7IWoF0F]: hasVariant(
                          $state,
                          "layout",
                          "withOffset"
                        )
                      }
                    )}
                    href={"https://o21p.com/support"}
                    platform={"react"}
                  >
                    {"support"}
                  </PlasmicLink__>
                }
                <React.Fragment>{" ]"}</React.Fragment>
              </React.Fragment>
            </div>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__b7Re,
                {
                  [sty.textlayout_full__b7ReT38D]: hasVariant(
                    $state,
                    "layout",
                    "full"
                  )
                }
              )}
            >
              {"team@o21p.com"}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

const PlasmicDescendants = {
  footer: [
    "footer",
    "contentWrapper2",
    "leftColumn2",
    "buttonNav2",
    "img",
    "rightColumn2"
  ],

  contentWrapper2: [
    "contentWrapper2",
    "leftColumn2",
    "buttonNav2",
    "img",
    "rightColumn2"
  ],

  leftColumn2: ["leftColumn2", "buttonNav2", "img"],
  buttonNav2: ["buttonNav2", "img"],
  img: ["img"],
  rightColumn2: ["rightColumn2"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicSectionFooter__ArgProps,
          internalVariantPropNames: PlasmicSectionFooter__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicSectionFooter__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "footer") {
    func.displayName = "PlasmicSectionFooter";
  } else {
    func.displayName = `PlasmicSectionFooter.${nodeName}`;
  }
  return func;
}

export const PlasmicSectionFooter = Object.assign(
  // Top-level PlasmicSectionFooter renders the root element
  makeNodeComponent("footer"),
  {
    // Helper components rendering sub-elements
    contentWrapper2: makeNodeComponent("contentWrapper2"),
    leftColumn2: makeNodeComponent("leftColumn2"),
    buttonNav2: makeNodeComponent("buttonNav2"),
    img: makeNodeComponent("img"),
    rightColumn2: makeNodeComponent("rightColumn2"),
    // Metadata about props expected for PlasmicSectionFooter
    internalVariantProps: PlasmicSectionFooter__VariantProps,
    internalArgProps: PlasmicSectionFooter__ArgProps
  }
);

export default PlasmicSectionFooter;
/* prettier-ignore-end */
